var form = require('./form.ejs');
var html = require('./html.ejs');

export default { form, html };